<template>
    <base-dialog :loading="loading" :value="dialog" :width="480" :fullscreen="isMobile" :title="$t('common.professional_info')"
        @input="val => { if (!val) hide() }" @close="hide">
        <professional-info v-if="dialog" no-title @change="professionalInfoData" ref="info"
            :description-key="isCompany ? 'company.description' : 'entrance.description'"
            :description-placeholder-key="isCompany ? 'company.description_placeholder' : 'entrance.description_placeholder'"
            :show-preparation="!isCompany" />

        <template v-slot:footer>
            <div class="footer-row">
                <v-btn depressed x-large class="footer-cancel" @click="hide">
                    {{ $t('common.cancel') }}
                </v-btn>
                <v-btn depressed x-large color="primary" class="footer-save black--text" @click="save"
                    :loading="loading">
                    {{ $t('common.save') }}
                </v-btn>
            </div>
        </template>
    </base-dialog>
</template>

<script>
import { mapActions } from "vuex";
import { db } from "@/utils/Firebase";
import ProfessionalInfo from './ProfessionalInfo.vue';
import BaseDialog from './BaseDialog.vue';

export default {
    name: "EditProfessionalInfoDialog",
    components: { ProfessionalInfo, BaseDialog },
    data() {
        return {
            dialog: false,
            loading: false,
            description: '',
            experience: '',
            sport_areas: [],
            professional_preparation: null,
        }
    },
    methods: {
        ...mapActions(['bindUserAccount']),
        show() {
            const vm = this
            vm.dialog = true
        },
        hide() {
            const vm = this
            vm.dialog = false
        },
        professionalInfoData(payload) {
            const vm = this
            vm.description = payload.description || ''
            vm.experience = payload.experience || ''
            vm.sport_areas = payload.sport_areas || []
            vm.professional_preparation = payload.professional_preparation ?? null
        },
        async save() {
            const vm = this
            if (vm.$refs.info) vm.$refs.info.emitNow()
            await vm.$nextTick()
            await vm.withLoading(async () => {
                let payload = {
                    description: vm.description,
                    experience: vm.experience,
                    sport_areas: vm.sport_areas?.map(sport => sport.name || sport.value || sport) || [],
                }

                if (vm.professional_preparation !== null) payload.professional_preparation = vm.professional_preparation

                await db.collection('users').doc(vm.currentUser.uid).update(payload)

                await vm.bindUserAccount(vm.currentUser)

                vm.hide()
                vm.toast(vm.$t('common.changes_saved'))
            })
        },
    },

}
</script>

<style scoped>
.footer-row {
    display: flex;
}

.footer-cancel {
    flex: 0 0 auto;
    border-radius: 0 !important;
    height: 52px !important;
    border-right: 1px solid var(--v-outline-base);
    background: var(--v-surface2-base) !important;
    color: var(--v-txtSecondary-base) !important;
    font-weight: 500;
}

.footer-save {
    flex: 1 1 auto;
    border-radius: 0 !important;
    height: 52px !important;
    font-weight: 700;
}
</style>